/**
 * LD Product Cart Form - Cart form handling and LD Cart Drawer integration
 */

class LDProductCartForm {
  constructor() {
    this.init();
  }

  /**
   * Initialize cart form handling
   */
  initCartForm() {
    console.log('LD Product Cart Form: Initializing cart form...');
    
    const form = document.querySelector('#product-form-ld-product-page');
    if (!form) {
      console.log('LD Product Cart Form: Cart form not found');
      return;
    }
    
    // Prevent default form submission
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('LD Product Cart Form: Form submission intercepted');
      
      // Get the currently selected variant from the form input
      let variantId = null;
      
      // Get variant ID from the hidden input (which is updated by variant selection)
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantId = variantInput.value;
        console.log('LD Product Cart Form: Got variant ID from form input:', variantId);
      }
      
      // Validate that we have a valid variant ID
      if (!variantId || variantId === '') {
        console.error('LD Product Cart Form: No variant ID found in form');
        alert('Please select a product option before adding to cart.');
        return false;
      }
      
      // Get quantity
      const quantity = parseInt(form.querySelector('input[name="quantity"]')?.value || 1);
      
      console.log('LD Product Cart Form: Adding to cart, variant:', variantId, 'quantity:', quantity);
      
      // Use LD cart drawer if available
      if (window.ldCartDrawer) {
        console.log('LD Product Cart Form: Using LD cart drawer...');
        window.ldCartDrawer.addToCartAndShow(variantId, quantity);
      } else {
        console.error('LD Product Cart Form: LD cart drawer not available - cart functionality disabled');
        alert('Cart functionality is not available. Please refresh the page and try again.');
      }
      
      return false;
    });
    
    console.log('LD Product Cart Form: Cart form initialized');
  }

  init() {
    this.initCartForm();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.ldProductCartForm = new LDProductCartForm();
});

// Export for ES modules
window.LDProductCartForm = LDProductCartForm;
